"use client";

import { c as _c } from "react/compiler-runtime";
import { FileText, ExternalLink, Download, Clock } from "lucide-react";
import { dealDocumentUrl } from "@/lib/deals/document-download/refs";
interface ContractPreviewProps {
  previewUrl?: string | null;
  generatedAt?: string | null;
  dealId: string;
  className?: string;
}

/**
 * ContractPreview - Shows contract preview link/download
 */
export function ContractPreview(t0) {
  const $ = _c(29);
  const {
    previewUrl,
    generatedAt,
    dealId,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  if (!previewUrl) {
    const t2 = `rounded-lg border border-zinc-200 bg-zinc-50 p-4 ${className}`;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="flex items-center gap-3"><div className="w-10 h-10 rounded-full bg-zinc-200 flex items-center justify-center flex-shrink-0"><Clock className="w-5 h-5 text-zinc-500" /></div><div><p className="font-medium text-zinc-700">Vertrag wird erstellt</p><p className="text-sm text-zinc-500">Der Vertrag wird gerade vorbereitet. Bitte haben Sie etwas Geduld.</p></div></div>;
      $[0] = t3;
    } else {
      t3 = $[0];
    }
    let t4;
    if ($[1] !== t2) {
      t4 = <div className={t2}>{t3}</div>;
      $[1] = t2;
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    return t4;
  }
  const t2 = `rounded-lg border border-zinc-200 bg-white p-4 ${className}`;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0"><FileText className="w-5 h-5 text-primary" /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <p className="font-medium text-zinc-900">Vertrag</p>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== generatedAt) {
    t5 = generatedAt && <>Erstellt am{" "}{new Date(generatedAt).toLocaleDateString("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      })}</>;
    $[5] = generatedAt;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <p className="text-sm text-zinc-500">{t5}</p>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== dealId) {
    t7 = dealDocumentUrl(dealId, "contract");
    $[9] = dealId;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ExternalLink className="w-4 h-4" />;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7) {
    t9 = <a href={t7} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-primary bg-primary/10 rounded-lg hover:bg-primary/15 transition-colors">{t8}Vertrag öffnen</a>;
    $[12] = t7;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== dealId) {
    t10 = dealDocumentUrl(dealId, "contract", {
      download: true
    });
    $[14] = dealId;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Download className="w-4 h-4" />;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10) {
    t12 = <a href={t10} className="inline-flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-zinc-700 bg-zinc-100 rounded-lg hover:bg-zinc-200 transition-colors">{t11}Herunterladen</a>;
    $[17] = t10;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12 || $[20] !== t9) {
    t13 = <div className="mt-3 flex flex-wrap gap-2">{t9}{t12}</div>;
    $[19] = t12;
    $[20] = t9;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t13 || $[23] !== t6) {
    t14 = <div className="flex items-start gap-3">{t3}<div className="flex-1 min-w-0">{t4}{t6}{t13}</div></div>;
    $[22] = t13;
    $[23] = t6;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="mt-4 p-3 bg-amber-50 border border-amber-200 rounded-lg"><p className="text-sm text-amber-800"><strong>Hinweis:</strong> Bitte prüfen Sie den Vertrag sorgfältig, bevor Sie die Bedingungen akzeptieren. Bei Fragen wenden Sie sich bitte an unser Team.</p></div>;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t14 || $[27] !== t2) {
    t16 = <div className={t2}>{t14}{t15}</div>;
    $[26] = t14;
    $[27] = t2;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  return t16;
}